import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { extendParentClass, extendBaseClass } from '../../../utils/classes'

export class Range extends Component {
  handleChange = (event) => {
    const { setMonthlyTextMessages } = this.props
    setMonthlyTextMessages(event.target.value)
  }

  baseClass = extendParentClass.bind(this)('range')

  extend = extendBaseClass.bind(this)

  max = 10000
  min = 100

  getPercentage = () => {
    const { monthlyTextMessages } = this.props
    const ratio = (monthlyTextMessages - this.min) / this.max
    return ratio * 100
  }

  render() {
    const { monthlyTextMessages } = this.props
    const percentage = this.getPercentage()
    return (
      <Form.Group controlId="range" className={this.baseClass}>
        <Form.Label hidden>Select Text Messages</Form.Label>
        <ProgressBar now={percentage} />
        <Form.Control
          type="range"
          min={this.min}
          max={this.max}
          value={monthlyTextMessages}
          onChange={this.handleChange}
          className={this.extend('slider')}
        />
      </Form.Group>
    )
  }
}

export default Range
